import React, { useState, useEffect, useMemo, useRef } from 'react'
import Link from 'next/link';
import Image from 'next/image';
import SectionHeading from '../Common/SectionHeading'
import DButton from '../elements/DButton';
import Table from '../DataTables/datatable';
import Toast from '../Common/Toast';
import CommonPopup from '../PopupForm/CommonPopup';
import * as Yup from 'yup';
import CallBackForm from '../Common/CallBackForm';
import axios from 'axios';

export default function EventBooking() {

    const [Search, setSearch] = useState("")
    const [ThepAreasSelected, setThepAreasSelected] = useState([])
    const [ThepAreasFiltered, setThepAreasFiltered] = useState([])
    const [EventsFiltered, setEventsFiltered] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [SelectedHTML, setSelectedHTML] = useState("");
    const [selectedArray, setSelectedArray] = useState([]);
    const [HtmlData, setHtmlData] = useState("");
    const [SelectedRaw, setSelectedRaw] = useState([]);
    const [dataEvents, setDataEvents] = useState([]);
    const dataEventsSelected = useRef([]);
    let originalArray = [];

    const getDateEvents = async () => {
        try {
            const response = await axios.get(process.env.API_URL + '/conference/date-events-conference');
            if (response.status !== 200) {
                throw new Error('Failed to fetch data');
            }
            const data = response.data;
            const newData = data.data.map((item) => {
                const startDate = new Date(item?.date?.split(' to ')[0]);
                const endDate = new Date(item?.date?.split(' to ')[1]);
                const date = startDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: undefined }) + ' to ' + endDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
                return {
                    date: date,
                    name: item?.name,
                    remark: item?.remark,
                    therapy_areas: item?.therapy_areas,
                    register: <button
                        type="button"
                        className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        onClick={() => {
                            popupFunction(item?.name)
                        }} >Register</button>
                }
            });
            originalArray = newData;
            setDataEvents(newData);
        } catch (error) {
            console.error('Error fetching home data:', error);
        }
    }

    useEffect(() => {
        getDateEvents();
    }, []);
    const openModal = () => {
        setIsModalOpen(true);
    };


    let selected = [];

    const closeModal = () => {
        selected = [];
        setIsModalOpen(false);
    };
    const [ThepAreas, setThepAreas] = useState([
        'Neurology',
        'Respiratory',
        'Rare',
        'Nephrology',
        'Oncology',
        'Dermatology',
        'Rheumatology',
        'Metabolic',
        'Hematology'
    ])

    // const dataEvents = [
    //     // {
    //     //     date: "18-20 Jan 2024",
    //     //     name: "ASCO GI (SF, CA)",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Oncology'
    //     //     ],
    //     //     active: false,
    //     //     register: <button
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "23-26 Feb 2024",
    //     //     name: "AAAAI (Washington DC)",
    //     //     remark: "American Academy of allergy, Asthma and immunology",
    //     //     therapy_areas: [
    //     //         'Dermatology'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "25-27 Jan 2024",
    //     //     name: "ASCO GU (SF, CA)",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Oncology'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "8-12 Mar 2024",
    //     //     name: "AAD (San Diego)",
    //     //     remark: "American Academy of Dermatology",
    //     //     therapy_areas: [
    //     //         'Dermatology'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "19-21 Mar 2024",
    //     //     name: "Rare Disease Summit",
    //     //     remark: "Not a platform for data readout as conducted by Informa group",
    //     //     therapy_areas: [
    //     //         'Rare'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "05-07 Apr 2024",
    //     //     name: "64th Annual Meeting of the Japanese Respiratory Society",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Respiratory'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "5-10 Apr 2024",
    //     //     name: "AACR (San Diego)",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Oncology'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "13-19 Apr 2024",
    //     //     name: "American Academy of Neurology (AAN) 76th Annual Meeting",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Neurology'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "13-16 Apr 2024",
    //     //     name: "World Congress of Nephrology (WCN) 2024",
    //     //     remark: "It doesn't look like a major one as its happening in Argentina, a LATAM country. Most of the participants are from developing countries",
    //     //     therapy_areas: [
    //     //         'Nephrology'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "23-25 Apr 2024",
    //     //     name: "World Orphan Drug Congress",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Rare'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "15-16 May 2024",
    //     //     name: "European Conference on Rare Diseases & Orphan products (ECRD)	",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Rare'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "16-19 May 2024",
    //     //     name: "MENA Congress for Rare Diseases",
    //     //     remark: "This is just Middle East region-focused congress",
    //     //     therapy_areas: [
    //     //         'Rare'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "17-22 May 2024",
    //     //     name: "ATS 2024 - American Thoracic Society International Conference",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Respiratory'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     // {
    //     //     date: "23-26 May 2024",
    //     //     name: "61st European Renal Association (ERA) Congress",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Nephrology'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // },
    //     {
    //         date: "31 May-Jun 4 2024",
    //         name: "ASCO (Chicago)",
    //         remark: "",
    //         therapy_areas: [
    //             'Oncology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "12-15 Jun 2024",
    //         name: "EULAR (Vienna)",
    //         remark: "European Alliance of Associations for Rheumatology",
    //         therapy_areas: [
    //             'Rheumatology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "13-16 Jun 2024",
    //         name: "EHA (Madrid, Spain)",
    //         remark: "The European Hematology Association",
    //         therapy_areas: [
    //             'Hematology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "13-16 June 2024",
    //         name: "Asian Pacific Congress of Nephrology (APCN)",
    //         remark: "APAC-centric congress, can't be a major one",
    //         therapy_areas: [
    //             'Nephrology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "21-24 Jun 2024",
    //         name: "ADA (Orlando, FL)",
    //         remark: "American Diabetes Association",
    //         therapy_areas: [
    //             'Metabolic'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "27-28 June 2024",
    //         name: "International Conference on COPD and Asthma",
    //         remark: "",
    //         therapy_areas: [
    //             'Respiratory'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "29 Jun - 2 Jul 2024",
    //         name: "10th Congress of the European Academy of Neurology (EAN) 2024",
    //         remark: "",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "28 July - 1 Aug 2024",
    //         name: "Alzheimer's Association International Conference (AAIC) 2024",
    //         remark: "This is just focused on Alzheimer's dis, so of course not a major neurology conference",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "4-6 Sep 2024",
    //         name: "Neurology World Conference 2024",
    //         remark: "Not a very promising past record of attendees, not a platform for data readout",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "7-11 Sept 2024",
    //         name: "European Respiratory Society (ERS) Annual Congress 2024",
    //         remark: "",
    //         therapy_areas: [
    //             'Respiratory'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "13-17 Sep 2024",
    //         name: "ESMO (Barcelona, Spain)",
    //         remark: "",
    //         therapy_areas: [
    //             'Oncology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "06-09 Oct 2024",
    //         name: "CHEST Annual Meeting 2024",
    //         remark: "",
    //         therapy_areas: [
    //             'Respiratory', 'Rare'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "21-23 Oct 2024",
    //         name: "International Conference on Neurology and Brain Disorders (INBC)",
    //         remark: "Can't be a major conference as its conducted by Magnus group",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "23-26 Oct 2024",
    //         name: "16th World Stroke Congress WSC 2024 by the World Stroke Organization",
    //         remark: "Can't be a major global conference as its happening in Abu Dhabi",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "23-27 Oct 2024",
    //         name: "American Society of Nephrology Kidney Week",
    //         remark: "",
    //         therapy_areas: [
    //             'Nephrology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "3-6 Nov 2024",
    //         name: "Obesity week (San Antonio)",
    //         remark: "",
    //         therapy_areas: [
    //             'Metabolic'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "14-19 Nov 2024",
    //         name: "ACR Convergence (Washington DC)",
    //         remark: "American College of Rheumatology",
    //         therapy_areas: [
    //             'Rheumatology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "7-10 Dec 2024",
    //         name: "ASH (San Diego)",
    //         remark: "American Society of Hematology",
    //         therapy_areas: [
    //             'Hematology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "7-10 Dec 2024",
    //         name: "American Society of Hematology (ASH) (San Diego)",
    //         remark: "",
    //         therapy_areas: [
    //             'Oncology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     }
    // ]


    // const dataEvents = [
    //     {
    //         date: "28 Feb - 3 Mar 2025",
    //         name: "American Academy of Allergy, Asthma, and Immunology (AAAAI)",
    //         remark: "American Academy of Allergy, Asthma, and Immunology (AAAAI)",
    //         therapy_areas: [
    //             'Respiratory, Immunology'
    //         ],
    //         register: <button
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "7-11 March, 2025",
    //         name: "American Academy of Dermatology (AAD) 2025",
    //         remark: "American Academy of Dermatology (AAD) 2025",
    //         therapy_areas: [
    //             'Dermatology'
    //         ],
    //         register: <button
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "5-9 April, 2025",
    //         name: "American Academy of Neurology (AAN)",
    //         remark: "American Academy of Neurology (AAN)",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "22-24 April, 2025",
    //         name: "World Orphan Drug Congress",
    //         remark: "World Orphan Drug Congress",
    //         therapy_areas: [
    //             'Rare'
    //         ],
    //         register: <button
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "25-30 April, 2025",
    //         name: "American Association for Cancer Research (AACR)",
    //         remark: "American Association for Cancer Research (AACR)",
    //         therapy_areas: [
    //             'Oncology'
    //         ],
    //         register: <button
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "4-7 May, 2025",
    //         name: "62nd European Renal Association (ERA) Congress",
    //         remark: "62nd European Renal Association (ERA) Congress",
    //         therapy_areas: [
    //             'Nephrology'
    //         ],
    //         register: <button
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "13-17 May, 2025",
    //         name: "ASGCT",
    //         remark: "ASGCT",
    //         therapy_areas: [
    //             'Miscellaneous'
    //         ],
    //         register: <button
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "18-21 May, 2025",
    //         name: "ATS 2025",
    //         remark: "ATS 2025",
    //         therapy_areas: [
    //             'Respiratory'
    //         ],
    //         register: <button
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "May 30-Jun 3, 2025",
    //         name: "American Society of Clinical Oncology (ASCO)",
    //         remark: "American Society of Clinical Oncology (ASCO)",
    //         therapy_areas: [
    //             'Oncology'
    //         ],
    //         register: <button
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "12–15 June, 2025",
    //         name: "EHA 2025 Congress",
    //         remark: "EHA 2025 Congress",
    //         therapy_areas: [
    //             'Hematology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "20-23 June, 2025",
    //         name: "American Diabetes Association (ADA)",
    //         remark: "American Diabetes Association (ADA)",
    //         therapy_areas: [
    //             'Hematology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "21-24 June, 2025",
    //         name: "11th Congress of the European Academy of Neurology (EAN) 2025",
    //         remark: "11th Congress of the European Academy of Neurology (EAN) 2025",
    //         therapy_areas: [
    //             'Hematology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "30 May-Jun 3 2025",
    //         name: "ASCO (Chicago)",
    //         remark: "",
    //         therapy_areas: [
    //             'Oncology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "11-14 June 2025",
    //         name: "EULAR (BARCELONA)",
    //         remark: "European Alliance of Associations for Rheumatology",
    //         therapy_areas: [
    //             'Rheumatology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "12-15 June 2025",
    //         name: "EHA (Milan, Italy)",
    //         remark: "The European Hematology Association",
    //         therapy_areas: [
    //             'Hematology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "5-7 Dec 2025",
    //         name: "Asian Pacific Congress of Nephrology (APCN)",
    //         remark: "APAC-centric congress, can't be a major one",
    //         therapy_areas: [
    //             'Nephrology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "20-23 June 2025",
    //         name: "ADA (Orlando, FL)",
    //         remark: "American Diabetes Association",
    //         therapy_areas: [
    //             'Metabolic'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "9-11 June 2025",
    //         name: "International Conference on COPD and Asthma",
    //         remark: "",
    //         therapy_areas: [
    //             'Respiratory'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "21-24 June 2025",
    //         name: "11th Congress of the European Academy of Neurology (EAN) 2025",
    //         remark: "",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "27-31 July 2025",
    //         name: "Alzheimer's Association International Conference (AAIC) 2025",
    //         remark: "This is just focused on Alzheimer's dis, so of course not a major neurology conference",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="text-white mt-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded text-sm px-4 py-2 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },

    //     {
    //         date: "5-7 Sep 2025",
    //         name: "Neurology World Conference 2025",
    //         remark: "Not a very promising past record of attendees, not a platform for data readout",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "27 Sept - 1 Oct 2025",
    //         name: "European Respiratory Society (ERS) Annual Congress 2025",
    //         remark: "",
    //         therapy_areas: [
    //             'Respiratory'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "17-21 Oct 2025",
    //         name: "ESMO (Berlin, Germany)",
    //         remark: "",
    //         therapy_areas: [
    //             'Oncology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "19-22 Oct 2025",
    //         name: "CHEST Annual Meeting 2025",
    //         remark: "",
    //         therapy_areas: [
    //             'Respiratory', 'Rare'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "20-22 Oct 2025",
    //         name: "International Conference on Neurology and Brain Disorders (INBC)",
    //         remark: "Can't be a major conference as its conducted by Magnus group",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "23-26 Oct 2025",
    //         name: "17th World Stroke Congress WSC 2025 by the World Stroke Organization",
    //         remark: "Can't be a major global conference as its happening in Abu Dhabi",
    //         therapy_areas: [
    //             'Neurology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "5-9 Nov 2025",
    //         name: "American Society of Nephrology Kidney Week",
    //         remark: "",
    //         therapy_areas: [
    //             'Nephrology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "4-7 Nov 2025",
    //         name: "Obesity week (Atlanta)",
    //         remark: "",
    //         therapy_areas: [
    //             'Metabolic'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "14-19 Nov 2025",
    //         name: "ACR Convergence (Washington DC)",
    //         remark: "American College of Rheumatology",
    //         therapy_areas: [
    //             'Rheumatology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     {
    //         date: "10 Jan - 1 Feb 2025.",
    //         name: "ASH (San Diego)",
    //         remark: "American Society of Hematology",
    //         therapy_areas: [
    //             'Hematology'
    //         ],
    //         register: <button 
    //             type="button"
    //             className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //             onClick={() => {
    //                 popupFunction()
    //             }} >Register</button>
    //     },
    //     // {
    //     //     date: "7-10 Dec 2024",
    //     //     name: "American Society of Hematology (ASH) (San Diego)",
    //     //     remark: "",
    //     //     therapy_areas: [
    //     //         'Oncology'
    //     //     ],
    //     //     register: <button 
    //     //         type="button"
    //     //         className="px-4 py-2 mt-2 mb-2 text-sm font-medium text-center text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    //     //         onClick={() => {
    //     //             popupFunction()
    //     //         }} >Register</button>
    //     // }
    // ]

    const columns = [
        {
            name: 'DATE',
            selector: row => row.date,
        },
        {
            name: 'CONFERENCE  NAMES',
            selector: row => row.name,
            width: "380px",                // added line here
            headerStyle: (selector, id) => {
                return { textAlign: "center" };   // removed partial line here
            },
        },
        {
            name: 'REGISTER',
            selector: row => row.register,
        },
    ];

    useEffect(() => {
        let htmlData = <>
            <div className="relative overflow-x-auto">
                <table className="w-full text-sm text-left text-gray-500 rtl:text-right dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">
                                Event name
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Event Date
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody className="h-20 overflow-scroll overflow-y-hidden">
                        {
                            selectedArray.map((item, index) =>
                                <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 truncate whitespace-nowrap dark:text-white">
                                        {item?.name}
                                    </th>
                                    <td className="px-6 py-4">
                                        {item?.date}
                                    </td>
                                    <td className="px-6 py-4">
                                        <button className="btn btn-danger btn-sm" onClick={() => {
                                            removeAction(item?.name)
                                        }}>Remove</button>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>

        </>
        setSelectedHTML(htmlData)

    }, [selectedArray]);

    const SetItem = (item, array, setArray) => {
        array.push(item)
        setArray(array)
    }

    const RemoveItem = (item, array, setArray) => {
        let valueToRemove = item;
        array = array.filter(items => items !== valueToRemove);
        setArray(array)
    }

    const searchTA = (term) => {
        let matches = ThepAreas.filter(item => item?.toLowerCase().includes(term.toLowerCase()));

        if (matches.length > 0) {
            setThepAreasFiltered(matches)
        } else {
            setThepAreasFiltered([]);
        }
    }

    function removeAction(name) {
        if (selectedArray.length == 1) {
            Toast("at least one event is required", 'error')
        } else {
            let new_array = [];
            selected.map((item, index) => {
                if (item?.name !== name) {
                    new_array.push(item)
                }
            })
            let arrData = []
            selectedArray.map((item) => {
                if (item?.name !== name) {
                    arrData.push({
                        name: item?.name,
                        date: item?.date
                    })
                }
            })
            setSelectedArray(arrData)
            selected = new_array
        }
    }

    const popupFunction = (name) => {
        selected = dataEventsSelected.current;
        let arrData = []
        const data = selected.map((item) => {
            return {
                name: item?.name,
                date: item?.date
            }
        })
        setSelectedArray(data)
        if (selected.length > 0) {
            openModal(true);
        } else {
            // Toast("Please select any event", 'error')
            const items = originalArray.filter(item => item?.name === name);
            selected = items;
            const singleData = items.map((item) => {
                return {
                    name: item?.name,
                    date: item?.date
                }
            })
            setSelectedArray(singleData)
            openModal(true);
        }
    }



    const memoizedData = useMemo(() => {
        return <Table selected={selected} data={(ThepAreasSelected.length > 0) ? (EventsFiltered.length > 0) ? EventsFiltered : [] : dataEvents} columns={columns} setData={(data) => {
            selected = data;
            dataEventsSelected.current = selected
        }} />
    }, [ThepAreasSelected, dataEvents]);




    function filterEvents() {
        const selectedTherapyAreas = ThepAreasSelected;

        // Filter events based on selected therapy areas
        const filteredEvents = dataEvents.filter(event =>
            event.therapy_areas.some(area => selectedTherapyAreas.includes(area.trim()))
        );
        selected = [];
        setEventsFiltered(filteredEvents);
    }




    const options = {
        btn_name: "Submit"
    }

    const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/


    const fields = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'phone',
            label: '',
            placeholder: 'Phone Number*',
            validation: Yup.string().required().matches(phoneRegExp, 'Phone number is not valid'),
            customClass: 'md:col-span-12 col-span-12'
        },
        {
            name: 'message',
            label: '',
            placeholder: 'Message',
            type: 'textarea',
            col_row: 2,
            customClass: 'md:col-span-12 col-span-12'
        },
    ];

    const fields_custom_events = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'event_name',
            label: '',
            placeholder: 'Event Name',
            customClass: 'md:col-span-12 col-span-12'
        },
        {
            name: 'message',
            label: '',
            placeholder: 'Message',
            type: 'textarea',
            col_row: 2,
            customClass: 'md:col-span-12 col-span-12'
        },
    ];

    return (
        <div className='flex flex-col justify-center w-11/12 mx-auto my-4 xl:max-w-screen max-w-screen-2xl lg:my-8'>
            <SectionHeading title="Register for Conference Coverage" customClass="text-center" />
            <CommonPopup isOpen={isModalOpen} closeModal={closeModal}
                fields={fields}
                options={options}
                page_name="Conference Coverage Inquiry"
                form_name="conference-coverage-inquiry"
                formTitle="Conference Coverage Inquiry"
                endpoint="/enquiry/conference-booking"
                captcha={true}
                custom_fields={[{
                    key: 'events',
                    value: selectedArray
                }]}
                footer={SelectedHTML} />
            <div className='grid grid-cols-12'>
                {/* Featured Article */}
                <div className="col-span-12 border">
                    <div className='grid grid-cols-12'>
                        <div className="w-full col-span-12 px-4 py-2 lg:col-span-4">
                            <h3 className="my-0 text-lg font-semibold line-clamp-3">
                                Therapy Area
                            </h3>
                            {/* <div className="my-2">
                                <input
                                    onChange={(e) => {
                                        setSearch(e.target.value)
                                        searchTA(e.target.value)
                                    }}
                                    value={Search}
                                    type="search"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Search"
                                />
                            </div> */}
                            {(Search != "") ?
                                <div className="h-20 overflow-hidden break-normal overflow-y-scoll">
                                    {ThepAreasFiltered.length > 0 ?
                                        ThepAreasFiltered.map((item, index) => (<span
                                            key={index}
                                            onClick={(() => {
                                                SetItem(item, ThepAreasSelected, setThepAreasSelected)
                                                RemoveItem(item, ThepAreas, setThepAreas)
                                                RemoveItem(item, ThepAreasFiltered, setThepAreasFiltered)
                                                filterEvents()
                                            })}
                                            className="inline-block cursor-pointer bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">{item}</span>))
                                        :
                                        <p className="inline-block p-2 my-2 cursor-pointer bg-blue-100 text-blue-800 text-sm font-medium me-2 spanx-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">No Result Found</p>
                                    }
                                </div>
                                :
                                <div className="h-20 overflow-hidden break-normal overflow-y-scoll">
                                    {ThepAreas.map((item, index) => (<span
                                        key={index}
                                        onClick={(() => {
                                            SetItem(item, ThepAreasSelected, setThepAreasSelected)
                                            RemoveItem(item, ThepAreas, setThepAreas)
                                            RemoveItem(item, ThepAreasFiltered, setThepAreasFiltered)
                                            filterEvents()
                                        })}
                                        className="inline-block cursor-pointer bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">{item}</span>))}
                                </div>
                            }
                            <div className="w-full h-full">
                                <hr />
                                <div className="w-full bg-white  z-10 lg:w-[100%]">
                                    <div className="flex justify-between w-full p-4 ">
                                        <h2 className="w-full text-lg ml-auto mr-auto font-semibold text-[#1b5df3]">{'Get Proposal to Cover Event of your Interest'}</h2>
                                    </div>
                                </div>
                                <CallBackForm
                                    fields={fields_custom_events}
                                    options={options}
                                    page_name={'Conference Requirements'}
                                    form_name={'conference_requirements'}
                                    className="mx-10"
                                    endpoint={'/enquiry/new-conference-booking'}
                                />
                            </div>
                        </div>
                        <div className="w-full col-span-12 px-4 py-2 lg:col-span-8">
                            <div className='w-full my-1'>

                                {ThepAreasSelected.map((item, index) => {
                                    return <span
                                        key={index}
                                        onClick={(() => {
                                            SetItem(item, ThepAreas, setThepAreas)
                                            RemoveItem(item, ThepAreasSelected, setThepAreasSelected)
                                            filterEvents()
                                        })}
                                        className="inline-block bg-pink-100 text-pink-800 text-xs font-medium me-2 px-2.5 cursor-pointer py-0.5 rounded-full dark:bg-pink-900 dark:text-pink-300">
                                        {item + " x"}
                                    </span>
                                })}
                            </div>
                            {
                                memoizedData
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
